var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoPlay = function SvgVideoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.644647 0.15264C0.820348 0.0509587 1.01699 0 1.21392 0C1.41032 0 1.60691 0.0509587 1.78337 0.15264L15.3556 10.0141C15.7073 10.2173 15.9251 10.5935 15.9251 11.0002C15.9251 11.4068 15.7079 11.783 15.3556 11.9859L1.78337 21.8478C1.43114 22.0507 0.996934 22.0507 0.644942 21.8478C0.292654 21.6441 0.0751953 21.2678 0.0751953 20.8614V1.13861C0.0751953 0.732118 0.292301 0.356003 0.644647 0.15264Z"
  })));
};
export default SvgVideoPlay;